// Wrap any route so the Web Editor can override it. If a PUBLISHED layout exists
// for `slug`, render it (with the site Navbar/Footer); otherwise render the
// original page unchanged. Safe fallback — nothing breaks if there is no edit.
import type { ReactNode } from "react";
import { usePublishedLayout } from "@/lib/cms";
import PublicBlockRenderer from "./PublicBlockRenderer";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function CmsSections({ slug, children }: { slug: string; children: ReactNode }) {
  const { loading, layout, found } = usePublishedLayout(slug);
  if (loading || !found || !layout) return <>{children}</>;
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">
        <PublicBlockRenderer blocks={layout} />
      </main>
      <Footer />
    </>
  );
}
